import React, {useEffect, useState} from 'react';
import Get from './components/Get';
import color from './components/color';
import MoreBottomTab from './MoreBottomTab';

const Passbook = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getWalletData = async () => {
    setLoading(true);
    try {
      const res = await Get.Wallet();
      setLoading(false);

      if (res.transection && res.transection.length > 0) {
        const flatTransactions = res.transection.flatMap(group => group.data);

        const mappedData = flatTransactions.map((item, index) => {
          let amtColor = 'black';
          if (item.transection === 'debit') {
            amtColor = item.status === 'success' ? 'red' : '#ffc107';
          } else {
            amtColor = item.status === 'success' ? 'green' : '#ffc107';
          }

          return (
            <div style={styles.cardRow} key={index}>
              <div style={styles.rowTop}>
                <p style={styles.gameName}>{item.message}</p>
                <p style={styles.dateText}>{item.date}</p>
              </div>
              <div style={styles.rowBottom}>
                <p style={styles.valueText}>Type: {item.transection}</p>
                <p style={{...styles.amountText, color: amtColor}}>
                  {item.transection === 'debit' ? '-' : '+'}
                  {item.amount}
                </p>
              </div>
            </div>
          );
        });

        setData(mappedData);
      } else {
        setData([]);
        alert('No wallet transactions found');
      }
    } catch (err) {
      setLoading(false);
      console.error('Wallet Fetch Error:', err);
      alert('Error: Could not load wallet data');
    }
  };

  useEffect(() => {
    getWalletData();
  }, []);

  return (
    <>
      <div style={styles.headerBar}>
        <h2 style={styles.headerTitle}>My Passbook</h2>
      </div>
      {loading ? (
        <div style={styles.loader}>Loading...</div>
      ) : (
        <div style={styles.scrollArea}>{data}</div>
      )}
      <MoreBottomTab />
    </>
  );
};

export default Passbook;

const styles = {
  headerBar: {
    height: '60px',
    backgroundColor: '#00318bff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderBottomLeftRadius: '20px',
    borderBottomRightRadius: '20px',
  },
  headerTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#fff',
    textAlign: 'center',
    margin: 0,
  },
  scrollArea: {
    maxHeight: 'calc(100vh - 80px)',
    overflowY: 'auto',
    padding: '10px',
  },
  cardRow: {
    backgroundColor: 'rgba(29, 185, 120, 0.41)',
    margin: '8px 16px',
    padding: '16px',
    borderRadius: '12px',
  },
  rowTop: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '8px',
  },
  gameName: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#333',
    margin: 0,
  },
  dateText: {
    fontSize: '12px',
    color: '#888',
    margin: 0,
  },
  rowBottom: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  valueText: {
    fontSize: '14px',
    color: '#444',
    margin: 0,
  },
  amountText: {
    fontSize: '14px',
    fontWeight: 'bold',
    margin: 0,
  },
  loader: {
    textAlign: 'center',
    padding: '20px',
    fontSize: '16px',
    fontWeight: 'bold',
    color: color.primary,
  },
};
